export default "__VITE_ASSET__79ae404e__"